import script from "./LayoutPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutPublic.vue?vue&type=script&setup=true&lang=js"

import "./LayoutPublic.vue?vue&type=style&index=0&id=55201f06&lang=css"

const __exports__ = script;

export default __exports__